import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import UserLockers from '../components/UserLockers';
import UserDetailsComponent from '../components/UserDetailsComponent';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import {
  LOCAL_STORAGE,
  LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS,
  USER_INFO,
} from '../assets/constants/BrowserStorageKeys';
import CircularProgressLoader from '../components/CircularProgressLoader';
import ButtonComponent from '../components/ButtonComponent';
import { useTranslation } from 'react-i18next';
import { getPathForNextPage } from '../lib/Utils';
import { HOME, USER_ACCOUNT } from '../assets/constants/PageList';
import ShowToast from '../components/ToastComponent';
import { TOAST_ERROR } from '../assets/constants/Constants';
import {
  fetchNearbyLockersForLocation,
  getCurrentBrowserLocation,
  getNearbyLockerErrorMessage,
} from '../lib/NearbyLockerUtils';

export default function UserProfilePage() {
  const history = useHistory();
  const { t } = useTranslation();
  const [userInfo, setUserInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingMessage, setLoadingMessage] = useState(t('loading_text'));
  const settings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS)
  const isAssignmentPricingEnabled = settings?.is_pricing;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setLoadingMessage(t('getting_user_data_text'));

        const user = await getSecureItemFromSpecificStorage(
          LOCAL_STORAGE,
          USER_INFO
        );

        if (user) {
          setUserInfo(user);
        } else {
          setUserInfo({
            username: 'anonymous',
            email: 'anonymous@gmail.com',
            mobile_number: '+91XXXXXXXXXX',
            date_joined: '01-01-2001',
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoadingMessage(t('something_went_wrong_text'));
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [t]);

  const redirectToMap = (locationDetails = null, lockersData = null) => {
    history.push({
      pathname: '/map',
      state: {
        ...(locationDetails && {
          center: locationDetails,
          useUserLocation: true,
        }),
        ...(lockersData && {
          lockersData,
          timestamp: Date.now(),
        }),
      },
    });
  };

  const fetchNearbyLockersAndRedirect = async (userLocation) => {
    const { lockersData } = await fetchNearbyLockersForLocation({
      userLocation,
      onLoadingMessage: setLoadingMessage,
    });

    redirectToMap(userLocation, lockersData);
    return true;
  };

  const handleToMapRedirect = async () => {
    const storedUserLocation = getSecureItemFromSpecificStorage(
      LOCAL_STORAGE,
      'userlocationDetails'
    );

    if (
      storedUserLocation?.lat &&
      storedUserLocation?.lng
    ) {
      try {
        setIsLoading(true);
        await fetchNearbyLockersAndRedirect(storedUserLocation);
      } catch (error) {
        console.error('Locker fetch error:', error);
        ShowToast(getNearbyLockerErrorMessage(error), TOAST_ERROR);
      } finally {
        setIsLoading(false);
      }
      return;
    }

    setIsLoading(true);
    setLoadingMessage('Getting your location...');

    try {
      const userLocation = await getCurrentBrowserLocation();
      await fetchNearbyLockersAndRedirect(userLocation);
    } catch (error) {
      console.error('Location or locker fetch error:', error);
      ShowToast(getNearbyLockerErrorMessage(error), TOAST_ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= UI ================= */
  return (
    <div className='user-profile-page'>
      {isLoading ? (
		<div className='main'>
			<CircularProgressLoader message={loadingMessage} />
		</div>
      ) : (
        <div className='main'>
          <div className='heading-container'>
            <h1 className='heading'>{t('my_account_title')}</h1>
            <p className='paragraph'>
              {/* {t('manage_bookings_and_subscription_text')} */}
              Manage your booking details and account information here.
            </p>
          </div>
        
          <div className='user-details-container'>
            <UserDetailsComponent userInfo={userInfo} onUserInfoUpdate={setUserInfo} />
          </div>
        {isAssignmentPricingEnabled &&
        <>
          <div className='user-profile-actions'>
            <div className='actions-title'>{t('quick_actions_title')}</div>
            <div className='actions-buttons'>
              <ButtonComponent
                handleClick={handleToMapRedirect}
                title={'book_in_advance'}
              />
              <ButtonComponent
                handleClick={() => history.push(getPathForNextPage(USER_ACCOUNT, HOME))}
                title={'active_bookings'}
              />
            </div>
          </div>
          <div className='user-lockers-container'>
			        <UserLockers/>
          </div>
          </>
          }
        </div>
      )}

    </div>
  );
}
